import { useEffect, useCallback, useRef } from "react";
import { clsx } from "clsx";
import CloseIcon from "@/common/images/icons/cross.svg?react";
import "./style/SwipePopup.scss";

interface ISwipePopupProps {
  onClose?: () => void;
  isOpen: boolean;
  children: React.ReactNode;
  title?: string;
}

export const SwipePopup = (props: ISwipePopupProps) => {
  const { onClose, isOpen, children, title } = props;
  const popupRef = useRef<HTMLInputElement>(null);

  const keyPress = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === "Escape" && isOpen && onClose) {
        onClose();
      }
    },
    [onClose, isOpen]
  );

  useEffect(() => {
    document.addEventListener("keydown", keyPress);

    return () => document.removeEventListener("keydown", keyPress);
  }, [keyPress]);

  const closePopup = (e: React.MouseEvent) => {
    if (popupRef.current === e.target && onClose) {
      onClose();
    }
  };

  const classes = clsx("SwipePopup", { "SwipePopup_isOpen": isOpen });

  return (
    <div onClick={closePopup} ref={popupRef} className="SwipePopup-MoreMenu">
      <div className={classes}>
        <div className="SwipePopup-Header">
          <span>{title}</span>
          <button className="SwipePopup-Close" onClick={onClose} aria-label="close popup">
            <CloseIcon />
          </button>
        </div>
        <div className="SwipePopup-Cnt">{children}</div>
      </div>
    </div>
  );
};
